import type { useJourneyNavigation } from "../hooks/useJourneyNavigation";

export type JourneyController = ReturnType<typeof useJourneyNavigation>;

interface JourneyNavigationProps {
  journey: JourneyController;
  variant?: "home" | "panel";
}

export function JourneyNavigation({
  journey,
  variant = "panel",
}: JourneyNavigationProps) {
  const { state, goPrevious, goNext } = journey;
  if (!state) return null;

  return (
    <nav
      className={`journey-navigation is-${variant}`}
      aria-label="Guided portfolio navigation"
    >
      <div className="journey-status" aria-live="polite">
        <span>{state.current.context}</span>
        <small>
          {state.position} / {state.total}
        </small>
      </div>
      <div className="journey-actions">
        <button
          type="button"
          onClick={goPrevious}
          disabled={!state.previous}
          aria-label={
            state.previous
              ? `Previous: ${state.previous.label}`
              : "Beginning of guided portfolio"
          }
        >
          <span aria-hidden="true">←</span>
          <span>{state.previous?.label ?? "Beginning"}</span>
        </button>
        <button
          type="button"
          onClick={goNext}
          disabled={!state.next}
          aria-label={
            state.next
              ? `Next: ${state.next.label}`
              : "End of guided portfolio"
          }
        >
          <span>{state.next?.label ?? "End of tour"}</span>
          <span aria-hidden="true">→</span>
        </button>
      </div>
      <p>
        <kbd>←</kbd>
        <kbd>→</kbd>
        <span>(arrow keys) to move through the orbit</span>
      </p>
    </nav>
  );
}
